<template>
  <div>
    <el-tabs v-model="activeTabName">
      <el-tab-pane name="订单" label="订单">
        <OrderPage v-if="activeTabName == '订单'" />
      </el-tab-pane>
      <el-tab-pane name="付费玩家" label="付费玩家">
        <PayPlayersPage v-if="activeTabName == '付费玩家'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderPage from "./OrderPage";
import PayPlayersPage from "./PayPlayersPage";
export default {
  data() {
    return {
      activeTabName: "订单",
    };
  },

  components: {
    OrderPage,
    PayPlayersPage,
  },
};
</script>